import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import routes from '../../../routes';

const AuthWrapper = ({ exact = false, path, component, auth = true, redirect }) => {
  return auth ? (
    <Route exact={exact} path={path} component={component} />
  ) : (
    <Redirect to={redirect || routes.Auth.Login.path} />
  );
};

export default AuthWrapper;
